const styles = theme => ({
    background:{
      backgroundColor: "#fbfaff", //body should have this background color in the main .css for the new site design 
      padding: "32px 0px",
      fontFamily: 'VodafoneRg-Regular',
      color: '#333333'
    },
  
    gridHeader: {
      background:'#F2EDFE',
      height: '74px',
      display: 'flex',
      alignItems: 'center',
      fontSize: '18px',
      paddingLeft: '32px',
      fontFamily: 'VodafoneRg-Bold'
    },
   
  })
  
  export default styles
  